import styled              from 'styled-components';

import { NavBarVariants  } from 'src/components/features/common/nav-bar';
import { ToolbarVariants } from 'src/components/features/main/common/toolbar';

import { themeColors, 
         cssFlexColumn,           
         cssFlexRowCC    } from 'src/providers/theme/shared';



export type RequirementsAndRecommendationsElementLayout = {
  backgroundColor: string;

  paddings: number[];
  scrollableGap: number;
  actionButtonPadding: number;
  layoutButtonPadding: number[];
  
  errorsIconColor: string;
  dividerColor: string;
  infoContainerColor: string;
  
  navbarVariant: NavBarVariants;
  toolbarVariant: ToolbarVariants;
  margin: number[];
  gap: number[];
  width: number; 
  height: number;
  iconWidth: number; 
  iconHeight: number;
  border: number
}

export const layout_light: RequirementsAndRecommendationsElementLayout = {
  backgroundColor: themeColors.BackgroundFillLight,

  paddings: [16, 24],
  scrollableGap: 8,
  actionButtonPadding: 20,
  layoutButtonPadding: [18, 16],

  errorsIconColor: themeColors.AccentRed1,
  dividerColor: themeColors.SecondaryGray3,
  infoContainerColor: themeColors.SecondaryGray2,

  navbarVariant: 'lightblue',
  toolbarVariant: 'light',
  gap: [6, 12, 16], 
  width: 100,
  height: 100,
  iconWidth: 32,
  iconHeight: 32,
  margin: [13],
  border: 1,
}

export const layout_dark: RequirementsAndRecommendationsElementLayout = {
  ...layout_light,
}

export const Screen = styled.div<{
  layout: RequirementsAndRecommendationsElementLayout,
}>`
  width: ${(args) => args.layout.width}vw;
  height:  ${(args) => args.layout.width}dvh;

  ${cssFlexColumn};

  background-color: ${(args) => args.layout.backgroundColor};
`

export const ScreenBody = styled.div<{
  layout: RequirementsAndRecommendationsElementLayout,
}>`
  ${cssFlexColumn};
  flex-grow: 2;
  gap: ${(args) => args.layout.gap[2]}px;
  padding: ${(args) => args.layout.paddings[1]}px;
`

export const InfoContainer = styled.div<{
  layout: RequirementsAndRecommendationsElementLayout,
}>`
  ${cssFlexRowCC}
  gap: ${(args) => args.layout.gap[1]}px;
  padding-bottom: ${(args) => args.layout.paddings[0]}px;
  border-bottom: ${(args) => args.layout.border}px solid ${(args) => args.layout.infoContainerColor};
`
export const RequirementsContainer = styled.div<{
  layout: RequirementsAndRecommendationsElementLayout,
}>`
  ${cssFlexColumn}
  justify-content: center;
  align-items: flex-start;
  gap: ${(args) => args.layout.gap[2]}px;
`

export const RequirementsItem = styled.div`
  ${cssFlexRowCC}
`

export const LinkContainer = styled.div<{
  layout: RequirementsAndRecommendationsElementLayout,
}>`
  ${cssFlexRowCC}
  color: ${themeColors.AccentBlue2};
  gap: ${(args) => args.layout.gap[0]}px;
`
export const IconContainer = styled.div<{
  layout: RequirementsAndRecommendationsElementLayout,
}>`
  width: ${(args) => args.layout.iconWidth}px;
  height: ${(args) => args.layout.iconHeight}px;
  ${cssFlexRowCC};
`

export const ViewContainer = styled.div<{
  layout: RequirementsAndRecommendationsElementLayout,
}>`
  ${cssFlexColumn};
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: ${(args) => args.layout.margin[0]}px;
`

export const WrongContainer = styled.div<{
  layout: RequirementsAndRecommendationsElementLayout,
}>`
  ${cssFlexRowCC}
  gap: ${(args) => args.layout.gap[1]}px;
`
